import * as React from "react";
import {useEffect, useState} from "react";
import {useIntl} from "react-intl";
import SearchIconButton from "../../../../../components/buttons/SearchIconButton";
import FormFieldText from "../../../../../components/FormFieldText";
import {VisitRequestDto} from "../../../../../modules/vms/dto/VisitRequestDto";
import {VisitRequestApi} from "../../../../../modules/vms/api/VisitRequestApi";
import {HttpStatus} from "../../../../../modules/common/enums/HttpStatus";
import {MessageUtils} from "../../../../../utils/MessageUtils";
import dayjs from "dayjs";
import {Formats} from "../../../../../constants/Formats";
import FormFieldDate from "../../../../../components/FormFieldDate";
import PreviousNextButton from "../../../../../components/PreviousNextButton";
import {AreaDto} from "../../../../../modules/vms/dto/AreaDto";
import FormFieldSelect from "../../../../../components/FormFieldSelect";
import {AreaApi} from "../../../../../modules/vms/api/AreaApi";
import {TENANT_ID} from "../../../../../constants/Profile";
import FormFieldSwitch from "../../../../../components/FormFieldSwitch";
import {UserDto} from "../../../../../modules/account/dto/UserDto";
import {DepartmentDto} from "../../../../../modules/account/dto/DepartmentDto";
import {DepartmentUserDto} from "../../../../../modules/vms/api/DepartmentUserDto";

export type RegisterVisitFormProps = {
    visitRequest: VisitRequestDto;
    onNext: (visitRequest: VisitRequestDto) => void;
};

const RegisterVisitForm: React.FC<RegisterVisitFormProps> = (props) => {
    const intl = useIntl();
    const [messageMap, setMessageMap] = useState(new Map<string, string>());
    const [innerVisitRequest, setInnerVisitRequest] = useState<VisitRequestDto>(props.visitRequest);
    const [searchMobile, setSearchMobile] = useState("");
    const [searchHostName, setSearchHostName] = useState("");
    // 部门+人员
    const [departmentList, setDepartmentList] = useState<Array<DepartmentUserDto>>([]);
    // 场所选择
    const [areaList, setAreaList] = useState<Array<AreaDto>>([]);
    // 要显示场所的名称
    const [areaNameMap, setAreaNameMap] = useState(new Map<string, string>());

    useEffect(() => {
        _fetchAreaList();
    }, []);

    useEffect(() => {
        setInnerVisitRequest(props.visitRequest);


    }, [props.visitRequest]);

    const _fetchAreaList = async () => {
        const responseResult = await AreaApi.getAreaList(undefined, TENANT_ID);
        if (responseResult.status === HttpStatus.SUCCESS) {
            const areaNameMap = new Map();
            for (let area of responseResult.data) {
                areaNameMap.set(area.id, area.name);
            }
            setAreaNameMap(areaNameMap);
            setAreaList(responseResult.data);
        }
    };

    const _handleChange = (name: string, value: any) => {
        if (name === 'arriveStartDate') {
            const newVisitRequest = {...innerVisitRequest};
            newVisitRequest.arriveStartDate = value;
            newVisitRequest.arriveEndDate = value;
            setInnerVisitRequest(newVisitRequest);
        }else if(name === 'departmentId'){
            const newVisitRequest = {...innerVisitRequest};
            newVisitRequest.hostUserId = value.userId;
            newVisitRequest.hostFullName = value.userName;
            newVisitRequest.hostMobile=value.userMobile;
            newVisitRequest.hostDepartmentId = value.id;
            newVisitRequest.hostDepartmentName = value.name;
            setInnerVisitRequest(newVisitRequest);
        }
        else {
            setInnerVisitRequest({...innerVisitRequest, [name]: value});
        }
    };

    const _handleNext = () => {
        if (!validate()) {
            return;
        }
        props.onNext(innerVisitRequest);
    };

    const validate = () => {
        const newMessageMap = new Map<string, string>();
        // if (innerVisitRequest.hostMobile === '') {
        //     newMessageMap.set('hostMobile', intl.formatMessage({id: 'VMS_VISIT_REQUEST_HOST_MOBILE_REQUIRED'}));
        // }
        if (innerVisitRequest.hostFullName === '') {
            newMessageMap.set('hostName', intl.formatMessage({id: 'VMS_VISIT_REQUEST_HOST_NAME_REQUIRED'}));
        }

        if (innerVisitRequest.hostDepartmentId === '') {
            newMessageMap.set('hostDepartmentId', intl.formatMessage({id: 'VMS_VISIT_REQUEST_HOST_DEPARTMENT_NAME_REQUIRED'}));
        }
        if (innerVisitRequest.arriveStartDate === '') {
            newMessageMap.set('arriveStartDate', intl.formatMessage({id: 'VMS_VISIT_REQUEST_ARRIVE_START_DATE_REQUIRED'}));
        }
        if (innerVisitRequest.purpose === '') {
            newMessageMap.set('purpose', intl.formatMessage({id: 'VMS_VISIT_REQUEST_PURPOSE_REQUIRED'}));
        }
        if (!innerVisitRequest.places || innerVisitRequest.places.length <= 0) {
            newMessageMap.set('places', intl.formatMessage({id: 'VMS_VISIT_REQUEST_PLACES_REQUIRED'}));
        }

        setMessageMap(newMessageMap);
        return newMessageMap.size <= 0;
    };

    const _handleCheckEmployee = async (mobile: string) => {
        if (mobile) {
            const responseResult = await VisitRequestApi.checkEmployeeByMobile(mobile);
            if (responseResult && responseResult.status === HttpStatus.SUCCESS) {
                if (responseResult.data) {
                    const newVisitRequest = {...innerVisitRequest};
                    newVisitRequest.hostMobile = mobile;
                    newVisitRequest.hostFullName = responseResult.data;
                    setInnerVisitRequest(newVisitRequest);
                } else {
                    MessageUtils.warning(intl.formatMessage({id: "VMS_VISIT_REQUEST_HOST_NOT_FOUND"}));
                }
            }
        }
    }
    const _handleCheckEmployeeByName = async (hostName: string) => {
        if (hostName) {
            const responseResult = await VisitRequestApi.searchEmployeeByName(hostName);
            if (responseResult && responseResult.status === HttpStatus.SUCCESS) {
                let resultData = responseResult.data;
                if (resultData) {
                    if (resultData.length > 0) {
                        let userList = Object.assign(new Array<UserDto>(), resultData);
                        const departList = new Array<DepartmentUserDto>();
                        userList.forEach((item: UserDto) => {
                            let department = item.department;
                            if(department){
                                let departmentUserDto = new DepartmentUserDto(  department, item);
                                departList.push(departmentUserDto)
                            }
                        })
                        setDepartmentList(departList);
                        if (departList.length == 1) {
                            const item =departList[0];
                            const newVisitRequest = {...innerVisitRequest};
                            newVisitRequest.hostUserId = item.userId;
                            newVisitRequest.hostMobile = item.userMobile;
                            newVisitRequest.hostFullName = item.userName;
                            newVisitRequest.hostDepartmentId = item.id;
                            newVisitRequest.hostDepartmentName = item.name;

                            setInnerVisitRequest(newVisitRequest);
                        }else{

                            const newVisitRequest = {...innerVisitRequest};
                            // newVisitRequest.hostUserId = "";
                            // newVisitRequest.hostMobile = "";
                            // newVisitRequest.hostFullName = "";
                            // newVisitRequest.hostDepartmentId = "";
                            // newVisitRequest.hostDepartmentName = "";

                            setInnerVisitRequest(newVisitRequest);
                        }

                    } else {
                        MessageUtils.warning(intl.formatMessage({id: "VMS_VISIT_REQUEST_HOST_NOT_FOUND"}));

                    }
                } else {
                    MessageUtils.warning(intl.formatMessage({id: "VMS_VISIT_REQUEST_HOST_NOT_FOUND"}));
                }
            }
        }
    }
    return (
        <div>
            <div>

                <FormFieldText label={intl.formatMessage({id: "VMS_VISIT_REQUEST_HOST_NAME"})}
                               placeholder={intl.formatMessage({id: "VMS_VISIT_REQUEST_HOST_NAME_SEARCH"})}
                               required={true} errorText={messageMap.get("hostName")}
                               value={searchHostName}
                               onBlur={()=>_handleCheckEmployeeByName(searchHostName)}
                               onChange={(value) => setSearchHostName(value)}
                               endAdornment={
                                   <div>
                                       <SearchIconButton
                                           onClick={() => _handleCheckEmployeeByName(searchHostName)}/>
                                   </div>
                               }
                />
                <FormFieldSelect label={intl.formatMessage({id: "VMS_VISIT_REQUEST_DEPARTMENT"})}
                                 required={true} errorText={messageMap.get("hostDepartmentId")}
                                 value={innerVisitRequest.hostDepartmentId}
                                 onChange={(value) => {
                                     let filter = departmentList.filter(item=>item.id===value);
                                     if(filter.length>0){
                                         _handleChange("departmentId", filter[0]);
                                     }
                                 }}
                                 items={departmentList.map((item) => {
                                     return {label: item.name+" "+ item.userName, value: item.id}
                                 })}/>
                {/*<FormFieldText label={intl.formatMessage({id: "VMS_VISIT_REQUEST_HOST_MOBILE"})}*/}
                {/*               placeholder={intl.formatMessage({id: "VMS_VISIT_REQUEST_HOST_MOBILE_SEARCH"})}*/}
                {/*               required={true} errorText={messageMap.get("hostMobile")}*/}
                {/*               value={searchMobile}*/}
                {/*               onChange={(value) => setSearchMobile(value)}*/}
                {/*               endAdornment={*/}
                {/*                   <div>*/}
                {/*                       <SearchIconButton*/}
                {/*                           onClick={() => _handleCheckEmployee(searchMobile)}/>*/}
                {/*                   </div>*/}
                {/*               }/>*/}
                {/*<FormFieldText label={intl.formatMessage({id: "VMS_VISIT_REQUEST_HOST_NAME"})}*/}
                {/*               required={true} errorText={messageMap.get("hostName")}*/}
                {/*               value={StringUtils.maskName(innerVisitRequest.hostFullName)}*/}
                {/*               disabled={true}/>*/}
                <FormFieldDate label={intl.formatMessage({id: "VMS_VISIT_REQUEST_ARRIVE_DATE"})}
                               required={true} errorText={messageMap.get("arriveStartDate")}
                               value={dayjs(innerVisitRequest.arriveStartDate, Formats.DATE_SIMPLE)}
                               minDate={dayjs()}
                               onChange={(value) => _handleChange("arriveStartDate", value)}/>
                <FormFieldText label={intl.formatMessage({id: "VMS_VISIT_REQUEST_PURPOSE"})}
                               required={true} errorText={messageMap.get("purpose")}
                               value={innerVisitRequest.purpose}
                               onChange={(value) => _handleChange("purpose", value)}/>
                <FormFieldSelect label={intl.formatMessage({id: "VMS_VISIT_REQUEST_PLACE"})}
                                 required={true} errorText={messageMap.get("places")}
                                 value={innerVisitRequest.places[0] && innerVisitRequest.places[0].areaId}
                                 onChange={(value) => {
                                     _handleChange("places", [{areaId: value, areaName: areaNameMap.get(value)}])
                                 }}
                                 items={areaList.map((item) => {
                                     return {label: item.name, value: item.id}
                                 })}/>
                <FormFieldText label={intl.formatMessage({id: "VMS_VISIT_REQUEST_TRANSPORT_GOODS"})}
                               value={innerVisitRequest.transportGoods}
                               onChange={(value) => {
                                   _handleChange("transportGoods", value)
                               }}/>
                <FormFieldSwitch label={intl.formatMessage({id: "VMS_VISIT_REQUEST_PERSONAL_GOODS_FLAG"})}
                                 checked={innerVisitRequest.personalGoodsFlag}
                                 onChange={(value) => {
                                     _handleChange("personalGoodsFlag", value)
                                 }}/>
                {innerVisitRequest.personalGoodsFlag &&
                <FormFieldText label={intl.formatMessage({id: "VMS_VISIT_REQUEST_PERSONAL_GOODS_DESCRIPTION"})}
                               value={innerVisitRequest.personalGoodsDescription}
                               onChange={(value) => {
                                   _handleChange("personalGoodsDescription", value)
                               }}/>}

            </div>
            <br/>
            <PreviousNextButton previousDisabled={true} onNext={_handleNext}/>
        </div>
    )
};

export default RegisterVisitForm;